import styled from '@emotion/styled'
import { Box, Flex } from 'theme-ui'

import media from '../../../common/MediaQueries'

const SectionContainerStyled = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  @media ${media.tablet} {
    flex-direction: row;
  }
`

const SectionContentStyled = styled(Flex)`
  flex-direction: column;
  width: 100%;
  margin-bottom: 1.25rem;

  @media ${media.tablet} {
    width: 34%;
    margin-bottom: 0;
  }
`

const SectionMediaStyled = styled(Flex)`
  position: relative;
  width: 100%;
  margin-bottom: 2.625rem;
  @media ${media.tablet} {
    width: 66%;
    margin-bottom: 0;
  }
`

const SectionButtonListStyled = styled(Flex)`
  flex-wrap: wrap;
  justify-content: center;

  @media ${media.tablet} {
    justify-content: flex-start;
  }
`

const SectionButtonListItemStyled = styled(Flex)`
  margin-bottom: 1.25rem;

  &:not(:last-of-type) {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: 1.25rem;' : 'margin-right: 1.25rem;')}
  }
`

export { SectionContainerStyled, SectionContentStyled, SectionMediaStyled, SectionButtonListStyled, SectionButtonListItemStyled }
